import React, { useContext } from "react";
import { Box, Typography, Grid, Link } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useNavigate } from "react-router-dom";
import companyLogo from "../assets/images/logo.png";
import { fontFamilyAll, COLORS } from "../assets/commonComponents/COLORS";
import { navigationData } from "../assets/commonComponents/data";
import  XIcon from '@mui/icons-material/X';
import { KnowledgeBaseContext } from "./knowledgeBaseContext/KnowledgeBaseContext";


const Footer = ({ handleScroll }) => {
  const navigate = useNavigate();
  
  // Social media links
  const socialLinks = {
    facebook: "https://www.facebook.com/companyname",
    twitter: "https://www.twitter.com/companyname",
    instagram: "https://www.instagram.com/companyname",
    linkedin: "https://www.linkedin.com/company/companyname"
  };
  const {setSearchString}=useContext(KnowledgeBaseContext)

  return (
    <Box sx={{ bgcolor: "#003087", color: "#fff", p: 4,maxHeight:800 }}>
      <Grid container spacing={4}>
        {/* Logo and Description */}
        <Grid item xs={12} md={3} textAlign={{ xs: "center", md: "left" }}>
          <img
            src={companyLogo}
            alt="Company Logo"
            width="150"
            style={{ maxWidth: "100%", height: "auto" }}
          />
          <Typography variant="body2" fontFamily={fontFamilyAll}>
            Payment processing is a critical component of any business that
            sells goods or services.
          </Typography>
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              gap: 1,
            }}
          >
            <Link href={socialLinks.facebook} color="inherit" target="_blank" rel="noopener">
              <FacebookIcon />
            </Link>
            <Link href={socialLinks.twitter} color="inherit" target="_blank" rel="noopener">
              <XIcon />
            </Link>
            <Link href={socialLinks.instagram} color="inherit" target="_blank" rel="noopener">
              <InstagramIcon />
            </Link>
            <Link href={socialLinks.linkedin} color="inherit" target="_blank" rel="noopener">
              <LinkedInIcon />
            </Link>
          </Box>
        </Grid>

        {/* Quick Links */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography
            variant="h6"
            fontWeight="bold"
            gutterBottom
            fontFamily={fontFamilyAll}
          >
            Quick Links
          </Typography>
          {navigationData.map((text, index) => (
            <Typography
              key={index}
              variant="body2"
              onClick={() => handleScroll(text?.toLowerCase())}
              sx={{
                mt: 1,
                transition: "color 0.3s",
                cursor: "pointer",
                "&:hover": { color: COLORS.whiteColor },
                "&:active": { color: COLORS.whiteColor },
              }}
              fontFamily={fontFamilyAll}
            >
              {text}
            </Typography>
          ))}
        </Grid>

        {/* Knowledge Base */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ color: "white", mb: 2, fontFamily: fontFamilyAll }}
          >
            Knowledge Base
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontFamily: fontFamilyAll, mb: 1 }}
          >
           Discover our range of articles and resources to keep up to date.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontFamily: fontFamilyAll,
              color: "white",
              cursor: "pointer",
              fontWeight: "bold",
              "&:hover": { color: COLORS.primaryColor },
            }}
            onClick={() => {
              navigate("/knowledgebase")
              setSearchString("")

            }}
          >
            Check out our Knowledge Base  →
          </Typography>
        </Grid>

        {/* Get in Touch */}
        <Grid item xs={12} md={3}>
          <Typography variant="h6" fontWeight="bold" gutterBottom fontFamily={fontFamilyAll}>
            Get in touch
          </Typography>
          <Typography variant="body2" fontFamily={fontFamilyAll}>
            Demo St, Brooklyn, NY 11223, United States
          </Typography>
          <Typography variant="body2" fontFamily={fontFamilyAll}>+1 123-456-7890</Typography>
          <Typography variant="body2" fontFamily={fontFamilyAll}>mail@example.com</Typography>
        </Grid>
      </Grid>

      {/* Bottom Section */}
      <Box
        sx={{
          mt: 4,
          borderTop: "1px solid #ccc",
          pt: 2,
          textAlign: "center",
        }}
      >
        <Typography variant="body2" fontFamily={fontFamilyAll}>
          Privacy Policy | Terms & Conditions | © 2025 Company Name. All rights
          reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;